import React, { useState, useEffect } from "react";
import "./style.css";
import Pageloader from "../../../../../components/loader";
import { Table, Tooltip, Typography } from "antd";
import { swalNotification } from "../../../../../components/alret/notificztion";
import ModalEditOrderRider from "../../../overviewView/components/modal/modalEditOrderRider";
import { overviewStatuses, dataKey, userhasPermissionHelper } from "../../../../../utils/Helpers";
import moment from "moment";
import { EnvironmentOutlined, ShopOutlined, HomeOutlined } from "@ant-design/icons";
import { getRidingTracking } from "../../../../../services/orderManagement.service";
import * as actionPage from "../../../../../redux/actions/orderManagementListing.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import GreenCircleIcon from "../../../../../components/svgs/indrive_icon";
import { PERMISSION_CONSTANT } from "../../../../../utils/constants/app";


const {Text}=Typography;
const OrderTableForm = (props) => {
  const [postData, setPostData] = useState(null);

  useEffect(() => {
    if(props.pageFilter) {
      // console.log(props.pageFilter)
      if(props.pageFilter.store_id || props.pageFilter.orderId){
        postLists(props.pageFilter)
      }
    }
  }, [props.pageFilter]);

  useEffect(() => {
    setPostData(dataKey(props.pageData));
  }, [props.pageData]);
  
  const postLists = async (data) => {
    const [start, end] = (data?.date === null || data?.date === undefined) ? "" : data?.date;
    const newData = {
      ...data,
      startDate: start === undefined ? moment() : start.toISOString(),
      endDate: end === undefined ? moment() : end.toISOString(),
      store_id: data?.store_id ? data?.store_id.toString() : undefined,
      return_pickup: data?.return_pickup ? data?.return_pickup.toString() : undefined,
      status: await statusChange(data?.union_status, data?.non_union_status),
    };
    const { date, union_status, non_union_status, ...rest } = newData;
    try {
      if (rest) {await props.actionPage.listAction(rest)}
    } catch (e) {}
  };

  const statusChange = async (union, non_union) => {
    let data = [...union !== undefined ? union : [], ...non_union !== undefined ? non_union : []].toString()
    return data || undefined
  }

  const paginationChange = async (page, limit) => {
    const pageData = {
      ...props.pageFilter,
      page: page,
      limit: limit,
    };
    await props.actionPage.filterAction(pageData);
  };

  const characterLength = (value) => {
    return value?.length > 15 ? `${value.substring(0, 15)}..` : value;
  };
  const characterLessLength = (value) => {
    const [string] = [value];
    const exclude = [ '-', 'Krave', 'Mart'];
    const words = exclude.reduce((str, word) => str.replaceAll(word, ''), string).replaceAll(/\s+/g, ' ');
    return words.length > 15 ? `${words.substring(0, 15)}...` : words;
  };

  const rlocdir = async (value, valLat, valLon)=>{
    try{
      const res = await getRidingTracking(value)
      if (res.data.code === 200 && res.data.data.length > 0){
          const resloc = res.data.data[0]
          return window.open(`https://www.google.com/maps/dir/${resloc.lat},${resloc.lon}/${valLat},${valLon}`);
      } else {
        swalNotification("", "Rider location not found", "error" )
      }
    } catch{}
  }

  const rloc = async (value)=>{
    try{
      const res = await getRidingTracking(value)
      if (res.data.code === 200 && res.data.data.length > 0){
          const resloc = res.data.data[0]
          return window.open(`https://maps.google.com/?q=${resloc.lat},${resloc.lon}`);
      } else {
        swalNotification("", "Rider location not found", "error" )
      }
    } catch{}
  }

  const columns = [
    {
      // title: 'Order Id',
      title: ()=><div >Order Id</div>,
      render: (value) => {
        return <div className="table-inner">
          <span>{value?._id || "-"}</span>
          <p>
            {value?.order_detail?.new_customer ? <Tooltip className="overvier-order-tags tags-green" title="New Customer">N</Tooltip> : ""}
            {value?.order_detail?.has_frozen_item ? <Tooltip className="overvier-order-tags tags-blue" title="Frozen item">F</Tooltip> : ""}
            {/* {value?.order_detail?.is_retailer ? <Tooltip className="overvier-order-tags tags-red" title="Retailer">R</Tooltip> : ""} */}
            {value?.order_detail?.urgent_delivery === true ? <Tooltip className="overvier-order-tags tags-yellow" title="Urgent Order">U</Tooltip> : ""}
            {value?.order_detail?.return_pickup === true ? <Tooltip className="overvier-order-tags tags-gray" title="Return Pickup Order">RP</Tooltip> : ""}
            {value?.order_detail?.cron_retry_count === true ? <Tooltip className="overvier-order-tags tags-red" title="Auto Assignment Limit Reached"></Tooltip> : ""}
            {value?.order_detail?.device_type == "indrive" ? <GreenCircleIcon /> : ""}
          </p>
        </div>;
      },
    },
    {
      title: 'Created At',
      dataIndex: 'order_detail',
      render: (value) => {
        return <><span>{moment(value.createdAt).format("DD MMMM, yyyy")}</span><p>{moment(value.createdAt).format("h:mm A")}</p></>;
      },
    },
    {
      title: 'Job Type',
      render: () => {
        return <><p>Pickup</p><p>Delivery</p></>;
      },
      dataIndex: '_id',
    },
    {
      title: 'Status',
      render: (value) => {
        return <>
         <p>{overviewStatuses(value.task_pickup.status.slug, "pickup",value.task_pickup.status.title)}</p>
         <p>{overviewStatuses(value.task_delivery.status.slug, "delivery",value.task_delivery.status.title)}</p>
        </>;
        // return <><p>{value.task_pickup.status.title}</p><p>{value.task_delivery.status.title}</p></>;
      },
    },
    {
      title: 'Address',
      // dataIndex: 'order_detail',
      render: (value) => {
        const hasPermission = userhasPermissionHelper(
          props.permissions,
          PERMISSION_CONSTANT.VIEW_CUSTOMER_ADDRESS
        );
        return <>
        <p><Tooltip title={value.order_detail.pickup.address}>{characterLessLength(value.storeName)}</Tooltip></p>
        <p>
          {hasPermission ? (
            <Tooltip title={value.order_detail.delivery.address}>
              {characterLength(value.order_detail.delivery.address)}
            </Tooltip>
          ) : (
            "-"   // no permission → show dash
          )}
        </p>
        {/* <p><Tooltip title={value.pickup.address}>{characterLessLength(value.pickup.address)}</Tooltip></p>
        <p><Tooltip title={value.delivery.address}>{characterLength(value.delivery.address)}</Tooltip></p> */}
        </>;
      },
    },
    {
      title: 'Customer Detail',
      dataIndex: 'order_detail',
      render: (value) => {
        return<>
          <span><Tooltip title={value?.delivery?.username}>{characterLength(value?.delivery?.username)}</Tooltip></span>
          <p>{value?.delivery?.phone_old_value}</p>
        </>;
      },
    },
    {
      title: 'Rider Detail',
      render: (value) => {
        const hasPhonePermission = userhasPermissionHelper(
          props.permissions,
          PERMISSION_CONSTANT.VIEW_Rider_PHONE
        );

        const rider = value.order_detail.rider;

        return (
          <>
            <div className="table-inner">

              {/* Rider Name */}
              {rider ? (
                <a onClick={() => showOrderRiderModal(rider._id)}>
                  <Tooltip title={rider.fullName}>
                    {rider.display_id} - {characterLength(rider.fullName)}
                  </Tooltip>
                </a>
              ) : (
                "-"
              )}

              {/* Rider Phone Based on Permission */}
              <span>
                {rider
                  ? hasPhonePermission
                    ? rider.phoneNumber
                    : "-"   // no permission
                  : "-"
                }
              </span>

              {/* Location Icons (stay same) */}
              {(value.task_delivery.status.slug === "completed" ||
                value.task_delivery.status.slug === "cancel") ? "" : (
                <span>
                  {rider && (
                    <>
                      <span>
                        <a onClick={() => rloc(rider._id)}>
                          <Tooltip title="Rider current location">
                            <EnvironmentOutlined />
                          </Tooltip>
                        </a>
                      </span>

                      <span>
                        <a onClick={() =>
                          rlocdir(
                            rider._id,
                            value.order_detail.pickup.latitude,
                            value.order_detail.pickup.longitude
                          )
                        }>
                          <Tooltip title="Store location">
                            <ShopOutlined />
                          </Tooltip>
                        </a>
                      </span>

                      <span>
                        <a onClick={() =>
                          rlocdir(
                            rider._id,
                            value.order_detail.delivery.latitude,
                            value.order_detail.delivery.longitude
                          )
                        }>
                          <Tooltip title="Customer location">
                            <HomeOutlined />
                          </Tooltip>
                        </a>
                      </span>
                    </>
                  )}
                </span>
              )}

            </div>
          </>
        );
      },
    },
    {
      title: 'Order Value',
      dataIndex: 'order_detail',
      render: (value) => {
        return value ? <>
          {value.total_amount || value.payment_type.slug !== "cod" ?(<p>Rs. {value.total_amount}</p>):"0"}
        </> : "";
      },
    },
    {
      title: 'COD Value',
      dataIndex: 'order_detail',
      render: (value) => {
        return value ? <>
          {value.total_amount && value.payment_type.slug === "cod" ?(<p>Rs. {value.total_amount}</p>):"0"}
        </> : 0;
      },
    },
    {
      title: 'Packed Time',
      dataIndex: 'order_detail',
      render: (value) => {
        return value && value.invoice && value.invoice.shipped_time ?
        <><span>{moment(value.invoice.shipped_time).subtract(5, "hours").format("DD MMMM, yyyy")}</span>
        <p>{moment(value.invoice.shipped_time).subtract(5, "hours").format("h:mm A")}</p></>:"-"
      },
    },
    {
      title: 'Picture Packed Time',
      dataIndex: 'order_detail',
      render: (value) => {
        return value && value.picker_packer && value.picker_packer.packer_time ?
        <><span>{moment(value.picker_packer.packer_time).format("DD MMMM, yyyy")}</span>
        <p>{moment(value.picker_packer.packer_time).format("h:mm A")}</p></>:"-"
      },
    },
    
    // {
    //   title: ()=><div onClick={()=>sortData("packed_time_")}>Delay <TableCaret value={"packed_time_"} sort={sc}/></div>,
    //   render: (value) => {
    //     var ms = moment(moment().format("DD/MM/YYY HH:mm:ss"),"DD/MM/YYYY HH:mm:ss").diff(moment(moment(value.order_detail.createdAt).format("DD/MM/YYY HH:mm:ss"),"DD/MM/YYYY HH:mm:ss"));
    //     var d = moment.duration(ms);
    //     return d ? (value.task_delivery.status.slug === "completed" || value.task_delivery.status.slug === "cancel") ? "":
    //       <Text type={ms/60000 < 15? "success":"danger"}>
    //         <span>{d._data.days === 0?"":d._data.days+"Day"}</span>
    //         <p>{('0'+d._data.hours).slice(-2)}:{('0'+d._data.minutes).slice(-2)}</p>
    //       </Text>: "-"
    //   },
    //   key: 'delay',
    // },
    {
      title: 'Delay',
      dataIndex: 'order_detail',
      render: (value) => {
        let time = value?.delay_time
        return time ? <Text type={time < 15? "success":"danger"}>
          <span>{Math.floor(time/24/60) === 0?"":Math.floor(time/24/60)+"Day"}</span>
          <p>{('0'+Math.floor(time/60%24)).slice(-2) + ':' + ('0'+Math.floor(time%60)).slice(-2)}</p>
        </Text>: "-"
      },
    },
  ];

  const [showModalOrderRider, setshowModalOrderRider] = useState(false);
  const [showModalOrderRiderID, setshowModalOrderRiderID] = useState(null);
  const showOrderRiderModal = (value) => {
    setshowModalOrderRiderID(value)
    setshowModalOrderRider(true);
  };
  
  return props.pageLoading ? (
    <Pageloader />
  ) : (
    <>
      <ModalEditOrderRider
        visible={showModalOrderRider}
        setvisible={setshowModalOrderRider}
        orderRiderID={showModalOrderRiderID}
      />
      <Table
        dataSource={postData}
        columns={columns}
        pagination={{
          total: props.pagePagination?.totalCount,
          showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
          pageSize: props.pagePagination?.limit,
          defaultCurrent: props.pagePagination?.currentPage,
          pageSizeOptions: ["10", "20", "30", "40", "50"],
          showSizeChanger: true,
          onChange: (currentPage, pageSize) => {
            paginationChange(currentPage, pageSize);
          },
        }}
        onRow={(r) => ({
          onDoubleClick: (e) => window.open(`/overview/${r._id}`),
        })}
      />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    pageData: state.OrderManagementListingReducer?.initialData,
    pagePagination: state.OrderManagementListingReducer?.initialPagination,
    pageLoading: state.OrderManagementListingReducer?.initialLoading,
    pageFilter: state.OrderManagementListingReducer?.initialFilter,
    permissions: state.PermissionReducer.permissions,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    actionPage: bindActionCreators(actionPage, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderTableForm);